import { Container } from '@/components';
import React, { useRef, useState } from 'react';
import FileUploadTemplate from '@/components/common/FileUpload/FileUploadTemplate';
import { useMarginCalculator } from '@/context/marginCalculatorContext/MarginCalculatorContextProvider';

const MarginCalculationByFile = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { calculateMarginByProductFile } = useMarginCalculator();
  const fileUploadRef = useRef(null);

  const handleFilesSelected = (files) => {
    setSelectedFiles(files);
  };

  const handleUpload = async (files) => {
    if (files.length > 0) {
      await calculateMarginByProductFile(files[0]);
      fileUploadRef.current.clearFiles();
    }
  };

  return (
    <Container title={' Load Product File'}>
      <div className="rounded-lg max-w-lg min-w-full">
        {/* Heading */}
        <div className="flex justify-center">
          <div>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4"></h2>
            <p className="text-gray-500 mb-6 text-center">
              Please upload a CSV file containing product data.
            </p>

            {/* File Upload */}
            <FileUploadTemplate
              maxFiles={1}
              ref={fileUploadRef}
              acceptedFileTypes={['.csv']}
              onFilesSelected={handleFilesSelected}
              onUpload={handleUpload}
            />
          </div>
        </div>

        {/* Error or Instruction Message */}
        <p className="text-center text-red-500 text-sm mb-4">
          * Note: The file should be in the following format.
        </p>

        {/* Table */}
        <div className="overflow-x-auto rounded-lg bg-gray-50 shadow-sm m-5">
          <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700 border">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Item Code
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Supplier
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Priority
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Conversion Factor
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  New Bye Price
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Major Group{' '}
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Minor Group
                </th>
                <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                  Special Case
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {/* Empty rows */}
              {Array.from({ length: 2 }).map((_, index) => (
                <tr key={index}>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                  <td className="py-2 px-4 text-center"></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Container>
  );
};

export default MarginCalculationByFile;
